export default __webpack_public_path__ + "static/media/Designer1.0f18ca64.png";